import { withCloseAfterExited } from "@10duke/dukeui";
import {
  AssignAdminModalProps,
  default as View
} from "./assign-admin-modal-view";

const AssignAdminModal = withCloseAfterExited<AssignAdminModalProps>(View);
export default AssignAdminModal;
